import { render, staticRenderFns } from "./forex-banner.vue?vue&type=template&id=11ce8aac&scoped=true"
import script from "./forex-banner.vue?vue&type=script&lang=js"
export * from "./forex-banner.vue?vue&type=script&lang=js"
import style0 from "./forex-banner.vue?vue&type=style&index=0&id=11ce8aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ce8aac",
  null
  
)

export default component.exports